module.exports = {
    openGraphImage: 'https://file.kbb.com/kbb/kbb-optimize/ttadblock/at_12_kellybluebk_notag_rgb.png',
    openGraphSiteName: 'KBB.com',
    openGraphType: 'product',
};
